import infoJson from './info.json';
const info = infoJson;
const languageDataByLocale = Object.entries(info).reduce((memo, [, languageData]) => {
    memo[languageData.acceptLanguage] = languageData;
    return memo;
}, {});
export const frodorLanguages = Object.keys(info);
export function getLanguageData(locale) {
    return info[locale] || languageDataByLocale[locale] || null;
}
//# sourceMappingURL=info.js.map